import { render, staticRenderFns } from "./amend-spassword.html?vue&type=template&id=7878e8c2&scoped=true&external"
import script from "./amend-spassword.js?vue&type=script&lang=js&external"
export * from "./amend-spassword.js?vue&type=script&lang=js&external"
import style0 from "./amend-spassword.scss?vue&type=style&index=0&id=7878e8c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878e8c2",
  null
  
)

export default component.exports